<template>
  <siquick-card title="School Settings">
    <template v-slot:card-content>
        <v-layout row wrap>

            <v-flex xs12>
                <v-text-field label="School Name*" v-model="sinf_model.school_name"/>
            </v-flex>
             <!-- <v-flex xs12>
                <v-text-field label="Logo*" v-model="sinf_model.logo"/>
            </v-flex> -->
             <v-flex xs12>
                <v-text-field label="Motto*" v-model="sinf_model.motto"/>
            </v-flex>
            <v-flex xs12>
                <v-text-field label="Address 1*"  v-model="sinf_model.address1"/>
            </v-flex>

            <v-flex xs12>
                <v-text-field label="Address 2"  v-model="sinf_model.address2"/>
            </v-flex>
              <v-flex xs12>
                <v-text-field label="Phone 1*"  v-model="sinf_model.phone1"/>
            </v-flex>

             </v-flex>
              <v-flex xs12>
                <v-text-field label="Phone 2"  v-model="sinf_model.phone2"/>
            </v-flex>
            <v-btn class="success" @click="savesetting()" :loading="loading">Save</v-btn>
        </v-layout>
    </template>
  </siquick-card>
</template>

<script>
import QuickCard from "../Quickcard";
import { mapGetters } from "vuex";
export default {
  name: "sms-settings",
  components: {
    "siquick-card": QuickCard
  },
  data(){
    return{
      sinf_model:{
        school_name:'',
        logo:'',
        motto:'',
        phone1:'',
        phone2:'',
        address1:'',
        address2:''
      },
       sinf_modelcp:{
        school_name:'',
        logo:'',
        motto:'',
        phone1:'',
        phone2:'',
        address1:'',
        address2:''
      },
    }
  },
   created() {
    this.$store.dispatch("settings/getAll")
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
      sierrors: "settings/SETTING_ERROR",
      loading: "settings/SETTING_LOADING"
    })
  },
  methods: {
      savesetting() {

        //console.log("pagtraaaaa",this.sinf_model)
      this.$store.dispatch("settings/add", this.sinf_model);

      if (this.sierrors==null) {

          this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Settings saved successfully",
                title: "Settings",
                modal: false
            })
      }else{
        this.sinf_model = this.sinf_modelcp;
          this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry, settings could not be saved",
                title: "Settings",
                modal: false
            })
      }
    },

  },
  watch:{
    settings(val){
       if (this.sierrors==null && this.settings.school) {
        this.sinf_model = this.settings.school;

      }
    }
  }


};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/settings/schoolInfo.vue